(function () {
  var root = document.querySelector('[data-impact-landing]');
  if (!root) return;

  var config = window.AssImpactConfig || {};
  var phase = root.getAttribute('data-voting-phase') || 'seed';
  var nominationsOpen = parseDate(root.getAttribute('data-nominations-open'));
  var nominationsClose = parseDate(root.getAttribute('data-nominations-close'));
  var votingOpen = parseDate(root.getAttribute('data-voting-open'));
  var votingClose = parseDate(root.getAttribute('data-voting-close'));

  updatePhasePanels();
  initParticipation();

  function updatePhasePanels() {
    var phases = root.querySelectorAll('[data-impact-phase]');
    phases.forEach(function (panel) {
      var kind = panel.getAttribute('data-impact-phase');
      var label = panel.querySelector('[data-impact-phase-label]');
      var countdown = panel.querySelector('[data-impact-phase-countdown]');
      if (!label || !countdown) return;

      var openDate;
      var closeDate;
      var openText;
      var activeText;
      var closedText;

      if (kind === 'nominations') {
        openDate = nominationsOpen;
        closeDate = nominationsClose;
        openText = 'Nominations open soon — active subscribers only';
        activeText = 'Nominations are open — subscribers submit one project per quarter';
        closedText = 'Nominations closed for this quarter';
      } else {
        openDate = votingOpen;
        closeDate = votingClose;
        openText = 'Community vote opens soon';
        activeText = 'Voting is open — one weighted vote per account (subscribers 5×)';
        closedText = 'Voting closed — winner announced on this page';
      }

      if (phase === 'seed') {
        label.textContent = kind === 'nominations' ? 'Opens after first quarterly gift' : 'Follows nomination window';
        countdown.textContent = '';
        return;
      }

      var now = new Date();
      if (phase === 'complete') {
        label.textContent = closedText;
        countdown.textContent = '';
        return;
      }

      if (kind === 'nominations' && phase === 'voting') {
        label.textContent = closedText;
        countdown.textContent = '';
        return;
      }

      if (kind === 'voting' && phase === 'nominations') {
        label.textContent = openText;
        countdown.textContent = formatCountdown(openDate, now, 'Opens in');
        return;
      }

      if (phase === kind) {
        label.textContent = activeText;
        countdown.textContent = formatCountdown(closeDate, now, 'Closes in');
        return;
      }

      if (openDate && now < openDate) {
        label.textContent = openText;
        countdown.textContent = formatCountdown(openDate, now, 'Opens in');
        return;
      }

      label.textContent = closedText;
      countdown.textContent = '';
    });
  }

  function initParticipation() {
    var nominatePanel = root.querySelector('[data-impact-nominate-panel]');
    var votePanel = root.querySelector('[data-impact-vote-panel]');
    var loginWall = root.querySelector('[data-impact-login-wall]');
    var voterStatus = root.querySelector('[data-impact-voter-status]');
    var subscriberUpsell = root.querySelector('[data-impact-subscriber-upsell]');

    if (phase === 'nominations') {
      var nominateUpsell = root.querySelector('[data-impact-nominate-upsell]');
      if (config.loggedIn) {
        if (loginWall) loginWall.hidden = true;
        if (voterStatus) voterStatus.hidden = false;
        loadVoterStatus();
        if (config.isSubscriber) {
          if (nominatePanel) nominatePanel.hidden = false;
          if (nominateUpsell) nominateUpsell.hidden = true;
          bindNominateForm();
        } else {
          if (nominatePanel) nominatePanel.hidden = true;
          if (nominateUpsell) nominateUpsell.hidden = false;
        }
      } else if (nominateUpsell) {
        nominateUpsell.hidden = false;
      }
    }

    if (phase === 'voting') {
      if (config.loggedIn) {
        if (loginWall) loginWall.hidden = true;
        if (voterStatus) voterStatus.hidden = false;
        if (votePanel) votePanel.hidden = false;
        loadVoterStatus();
        loadNominees();
        if (subscriberUpsell && !config.isSubscriber) {
          subscriberUpsell.hidden = false;
        }
      } else if (votePanel) {
        votePanel.hidden = true;
      }
    }
  }

  function bindNominateForm() {
    var form = root.querySelector('[data-impact-nominate-form]');
    if (!form) return;

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var status = root.querySelector('[data-impact-nominate-status]');
      var data = new FormData(form);
      var payload = {
        church_name: data.get('church_name'),
        location: data.get('location'),
        project_url: data.get('project_url'),
        fund_url: data.get('fund_url'),
        description: data.get('description'),
      };

      if (status) status.textContent = 'Submitting…';
      apiPost('/nominate', payload)
        .then(function (result) {
          if (status) status.textContent = result.message || result.error || 'Done';
          if (result.ok) form.reset();
        })
        .catch(function (err) {
          if (status) status.textContent = err.message || 'Unable to submit nomination';
        });
    });
  }

  function loadVoterStatus() {
    var weightEl = root.querySelector('[data-impact-voter-weight]');
    apiGet('/voter-status')
      .then(function (result) {
        if (!weightEl || !result.logged_in) return;
        var subWeight = result.vote_weight || config.subscriberVoteWeight || 5;
        var memberWeight = config.memberVoteWeight || 1;
        if (result.is_active_subscriber || result.is_subscriber) {
          weightEl.textContent =
            'Active subscriber — your vote counts ' + subWeight + '× on all quarterly building fund selections.';
        } else {
          weightEl.textContent =
            'Community member — your vote counts ' + memberWeight + '×. Subscribe to boost your vote to ' + subWeight + '×.';
        }
      })
      .catch(function () {
        if (weightEl) weightEl.textContent = '';
      });
  }

  function loadNominees() {
    var list = root.querySelector('[data-impact-nominee-list]');
    var status = root.querySelector('[data-impact-vote-status]');
    if (!list) return;

    list.textContent = 'Loading nominees…';
    apiGet('/nominees')
      .then(function (result) {
        list.textContent = '';
        if (!result.nominees || !result.nominees.length) {
          list.textContent = 'Nominees will appear here once the shortlist is published.';
          return;
        }

        result.nominees.forEach(function (nominee) {
          var card = document.createElement('label');
          card.className =
            'flex cursor-pointer gap-3 rounded-lg border border-cream/10 bg-navy p-4 hover:border-gold/40';

          var selected = result.my_vote_nominee_id === nominee.id;
          card.innerHTML =
            '<input type="radio" name="impact_nominee" value="' +
            escapeHtml(nominee.id) +
            '" class="mt-1" ' +
            (selected ? 'checked disabled' : '') +
            '>' +
            '<span class="min-w-0 flex-1">' +
            '<span class="block font-semibold text-cream">' +
            escapeHtml(nominee.church_name) +
            '</span>' +
            (nominee.location
              ? '<span class="mt-1 block text-xs text-cream/60">' + escapeHtml(nominee.location) + '</span>'
              : '') +
            (nominee.description
              ? '<span class="mt-2 block text-sm text-cream/70">' + escapeHtml(nominee.description) + '</span>'
              : '') +
            (nominee.project_url
              ? '<a href="' +
                escapeHtml(nominee.project_url) +
                '" class="mt-2 inline-block text-xs text-gold-light underline" target="_blank" rel="noopener noreferrer">Project page</a>'
              : '') +
            (nominee.fund_url
              ? '<a href="' +
                escapeHtml(nominee.fund_url) +
                '" class="mt-1 inline-block text-xs text-gold-light underline" target="_blank" rel="noopener noreferrer">Building fund</a>'
              : '') +
            '<span class="mt-2 block text-xs text-gold-light">' +
            nominee.weighted_votes +
            ' weighted votes</span>' +
            '</span>';

          if (!selected) {
            card.querySelector('input').addEventListener('change', function () {
              submitVote(nominee.id, status);
            });
          }

          list.appendChild(card);
        });

        if (result.my_vote_nominee_id && status) {
          status.textContent = 'You already voted this quarter. Thank you!';
        }
      })
      .catch(function (err) {
        list.textContent = err.message || 'Unable to load nominees';
      });
  }

  function submitVote(nomineeId, statusEl) {
    if (statusEl) statusEl.textContent = 'Recording your vote…';
    apiPost('/vote', { nominee_id: nomineeId })
      .then(function (result) {
        if (statusEl) statusEl.textContent = result.message || result.error || 'Done';
        if (result.ok) loadNominees();
      })
      .catch(function (err) {
        if (statusEl) statusEl.textContent = err.message || 'Unable to record vote';
      });
  }

  function apiGet(path) {
    return fetch(config.apiBase + path, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    }).then(handleResponse);
  }

  function apiPost(path, body) {
    return fetch(config.apiBase + path, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    }).then(handleResponse);
  }

  function handleResponse(response) {
    return response.json().then(function (data) {
      if (!response.ok) {
        var err = new Error(data.error || 'Request failed');
        if (response.status === 401 && !config.loggedIn) {
          err.message = 'Log in or create a free account to continue.';
        }
        throw err;
      }
      return data;
    });
  }

  function parseDate(value) {
    if (!value) return null;
    var date = new Date(value);
    return isNaN(date.getTime()) ? null : date;
  }

  function formatCountdown(target, now, prefix) {
    if (!target) return '';
    var ms = target - now;
    if (ms <= 0) return '';
    var days = Math.ceil(ms / 86400000);
    return prefix + ' ' + days + ' day' + (days === 1 ? '' : 's');
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }
})();
